<template>
  <el-form-item class="elsa-input" show-message :label="$attrs.label" :prop="$attrs.prop" :name="$attrs.name">
    <template slot="label" v-if="(displayCount && maxTags) || information">
      {{ $attrs.label }}
      <el-tooltip v-if="information" :content="information" popper-class="white-space-pre-line">
        <i class="el-icon-info" />
      </el-tooltip>
      <span class="count-elem" v-if="displayCount && maxTags && displayCountPosition == 'label'">{{ tagCount }}/{{ maxTags }} {{ $t(suffixDisplayCount) }}</span>
    </template>
    <vue-tags-input
      class="elsa-input elsa-tags-input"
      :class="{ 'elsa-tags-input-custom': displayTagsInRow}"
      v-model="tag"
      :tags="currentTags"
      :add-on-blur="true"
      :max-tags="maxTags"
      :placeholder="$attrs.placeholder"
      :validation="[]"
      :add-from-paste="true"
      :separators="separators"
      :add-on-key="addOnkey"
      :save-on-key="[13, '\n', ';']"
      @tags-changed="handleChange"
      :allow-edit-tags="allowEditTags"
      v-on:before-editing-tag="handleBeforeEditingTag"
      v-on:before-adding-tag="handleBeforeAddingTag"
      v-on:before-saving-tag="handleBeforeSavingTag"
      v-on:adding-duplicate="handleAddingDuplicate"
      :is-duplicate="isDuplicate"
    >
    <div
      slot="tag-right"
      slot-scope="props"
      class="check-spell"
      @click="viewCheck(props)"
    >
      <el-popover
        v-if="props.tag.suggestion && props.tag.suggestion.length > 0"
        placement="right"
        width="300"
        v-model="props.tag.suggestion_visible">
        <popover-spelling-suggestion
          v-on:ignore_all="handleIgnoreall"
          v-on:replace_all="handleReplaceall"
          v-on:replace_one="handleReplaceone"
          v-on:remove_item="handleRemoveitem"
          v-on:remove_word="handleRemoveword"
          v-on:add_word="handleAddword"
          :props="props"
          :spellcheck_resp="props.tag.suggestion"
        />
        <i slot="reference" class="elsa-icon-question" />
      </el-popover>
      <el-popover
        v-if="props.tag.limit_error"
        placement="right"
        v-model="props.tag.suggestion_visible">
        <popover-limit-character-suggestion
          :props="props"
        />
        <i slot="reference" class="elsa-icon-question" />
      </el-popover>
      <el-popover
        v-if="props.tag.is_cleanup && !props.tag.loading"
        placement="right"
        v-model="props.tag.suggestion_visible">
        <popover-clean-up-suggestion
          v-on:using_cleanup_text="handleUsingCleanUpText"
          :props="props"
        />
        <i slot="reference" class="elsa-icon-question" />
      </el-popover>
      <i v-if="props.tag.loading" class="elsa-icon-progress rotate" />
    </div>
    <div
      slot="tag-center"
      slot-scope="props"
    >
      <span
        v-if="!props.edit"
        @click="handleEdit(props)"
      >
        {{ props.tag.text }}
      </span>
      <div
        v-else
        class="tag-edit"
      >
        <el-input 
          type="textarea" 
          @input="handleInputTag(props)" 
          autosize 
          autofocus
          ref="edititem"
          class="ti-tag-input"
          v-model="props.tag.text"
          >
        </el-input>
        <i slot="reference" @click="props.performSaveEdit(props.index)" class="ti-icon-check" />
      </div>
    </div>
    <div
      slot="tag-actions"
      slot-scope="props"
    >
    <i v-if="props.edit" slot="reference" @click.prevent.self="handleUndo(props)" class="ti-icon-undo" />
    <i v-if="!props.edit" slot="reference" @click.prevent.self="handleDelete(props)" class="ti-icon-close" />
    </div>
    </vue-tags-input>
    <span class="count-elem" v-if="displayCount && maxTags && displayCountPosition == 'bottom'"> {{ tagCount }}/{{ maxTags }} {{ $t(suffixDisplayCount) }}</span>
    <span class="warning-label" :class="{ 'warning-label--custom': displayTagsInRow}" v-if="hasSpellError" >
      {{ $t('common.tag_input.there_are_spelling_grammar') }}
      {{ $t('common.tag_input.click_icon') }}
      <i slot="reference" class="elsa-icon-question" /> 
      {{ $t('common.tag_input.text_icon_for_suggestions') }} 
    </span>
    <span class="warning-label" :class="{ 'warning-label--custom': displayTagsInRow}" v-if="hasLimitError" >
      {{ $t('common.tag_input.tag_input_max_length_warning', {max_length: maxCharactersAllow}) }}
      {{ $t('common.tag_input.click_icon') }}
      <i slot="reference" class="elsa-icon-question" /> 
      {{ $t('common.tag_input.text_icon_for_suggestions') }} 
    </span>
    <span class="cleanup-label" v-if="hasCleanupText" >
      {{ $t('common.tag_input.tag_input_cleanup_text_warning') }}
      {{ $t('common.tag_input.click_icon') }}
      <i slot="reference" class="elsa-icon-question" /> 
      {{ $t('common.tag_input.make_changes_to_the_cleaned_text') }}
    </span>
 
  </el-form-item>
</template>

<script>
import {VueTagsInput} from '@johmun/vue-tags-input'
import { successMessage, warningMessage } from '@/utils/messages'
import PopoverSpellingSuggestion from '@/components/studysets//PopoverSpellingSuggestion'
import PopoverLimitCharacterSuggestion from '@/components/studysets//PopoverLimitCharacterSuggestion'
import PopoverCleanUpSuggestion from '../studysets/PopoverCleanUpSuggestion.vue'
import axios from '@/utils/axios'
import { de } from 'date-fns/locale'

export default {
  components: {
    VueTagsInput,
    PopoverSpellingSuggestion,
    PopoverLimitCharacterSuggestion,
    PopoverCleanUpSuggestion
  },
  props: {
    currentTags: {
      type: Array,
      default: () => []
    },
    displayCount: {
      type: Boolean,
      default: false
    },
    maxTags: {
      type: Number,
      default: undefined
    },
    separators: {
      type: Array,
      default: () => ['\n', '\r\n', ';', ',']
    },
    information: {
      type: String,
      default: null
    },
    displayCountPosition: {
      type: String,
      default: 'label'
    },
    suffixDisplayCount: {
      type: String,
      default: 'items'
    },
    addFromPaste: {
      type: Boolean,
      default: true
    },
    addOnkey: {
      type: Array,
      default: () => ['\n', '\r\n', ';', ',']
    },
    allowEditTags: {
      type: Boolean,
      default: false
    },
    maxCharactersAllow: {
      type: Number,
      default: undefined
    },
    displayTagsInRow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tag: '',
      tagCount: 0,
      editIndex: -1,
      hasSpellError: false,
      hasLimitError: false,
      hasCleanupText: false,
    }
  },
  computed: {
  },
  mounted() {
    this.tagCount = this.currentTags.length;
    this.hasSpellError = this.currentTags.filter(tag => tag.classes && tag.spell_error).length > 0;
    this.hasLimitError = this.currentTags.filter(tag => tag.classes && tag.limit_error).length > 0;
    this.hasCleanupText = this.currentTags.filter(tag => tag.classes && tag.is_cleanup).length > 0;
  },
  methods: {
    handleDelete(props) {
      props.performDelete(props.index);
      this.editIndex = -1;
    },
    handleUndo(props) {
      props.performCancelEdit(props.index); 
      props.performSaveEdit(props.index);
    },
    handleEdit(props) {
      if(this.editIndex >= 0 && this.editIndex != props.index) {
        warningMessage(this.$t('common.tag_input.only_one_item_edit_same_time'), 'elsa-message warning', {
          showClose: false,
          duration: 5000,
        })(this);
        return false;
      }
      props.performOpenEdit(props.index);
      this.editIndex = props.index;
      this.$nextTick(() => {
        this.$refs.edititem.focus();
      });
    },
    handleInputTag(props) {
      if(props.tag.text.length - this.maxCharactersAllow >= 0)
        props.tag.character_limit = props.tag.text.length - this.maxCharactersAllow;
      else
        props.tag.character_limit = 0;
    },
    handleChange(tags) {
      this.$emit('updatedTags', tags)
    },
    handleBeforeEditingTag(obj) {
      delete obj.success
      delete obj.error
      obj.editTag()
    },
    async handleBeforeAddingTag(obj) {
      obj.tag.text = obj.tag.text.trim().replace(/\s+/g, " ");
      if(this.maxCharactersAllow > 0) {
        this.resetSpellError(obj);
        this.checkMaxLength(obj)
      }
      if(!obj.tag.limit_error) {
        const action="ADD";
        obj.tag.loading = true;
        this.checkSpellAndCleanTag(obj, action)
      }
      this.editIndex = -1;
      obj.addTag()
    },
    async checkSpellAndCleanTag(obj, action) {
      await this.getComputedDictionary(obj)
      this.getSpellcheckApi(obj, action)
    },
    async handleBeforeSavingTag(obj) {
      obj.tag.text = obj.tag.text.trim().replace(/\s+/g, " ");
      if(this.maxCharactersAllow > 0) {
        this.resetSpellError(obj);
        this.checkMaxLength(obj)
      }
      if(!obj.tag.limit_error) {
        const action="EDIT";
        obj.tag.loading = true;
        await this.getComputedDictionary(obj)
        await this.getSpellcheckApi(obj, action)
      }
      this.editIndex = -1;
      obj.saveTag()
    },
    isDuplicate(tags, tag) {
      return tags.map((t) => t.text).indexOf(tag.text) !== -1 || tags.map((t) => t.text.trim()).indexOf(tag.text.trim()) !== -1
    },
    checkMaxLength(obj) {
      if (obj.tag.text.length > this.maxCharactersAllow) {
        obj.tag.classes = "limit-error";
        obj.tag.limit_error = true;
        obj.tag.character_limit = obj.tag.text.length - this.maxCharactersAllow;
      } else {
        delete obj.tag.classes;
        delete obj.tag.limit_error;
        delete obj.tag.character_limit;
      }
      return true;
    },
    resetSpellError(obj) {
      delete obj.tag.classes;
      delete obj.tag.suggestion;
      delete obj.tag.spell_error;
      delete obj.tag.suggestion_visible;
    },
    handleAddingDuplicate(){
      warningMessage(this.$t('common.adding_duplicate_warning'), 'elsa-message warning', {
          showClose: false
      })(this)
    },
    viewCheck(props) {
      props.tag.suggestion_visible = true;
    },
    handleIgnoreall(props) {
      props.tag.suggestion_visible = false;
    },
    async handleReplaceall(props){
      props.tag.suggestion_visible = false;
      props.performOpenEdit(props.index)
      const length = props.tag.suggestion.length;
      for (var i = 0; i < length; i++) {
        const item = props.tag.suggestion[0];
        if(item.type == 'grammar' && item.suggestion == '') {
          props.tag.text = this.removeAt(props.tag.text, item.start_index, item.end_index, '');
        } else if(item.type == 'grammar' && item.original == '') {
          props.tag.text = [props.tag.text.slice(0, item.start_index), " " + item.suggestion, props.tag.text.slice(item.start_index)].join('');
        } else
          props.tag.text = this.removeAt(props.tag.text, item.start_index, item.end_index, item.suggestion);

        const url = `v1/study-sets/spellcheck`;
        const payload = {"text": props.tag.text};
        await axios.post(url, payload).then(resp => {
          if(resp.data.resp && resp.data.resp.length > 0) {
            props.tag.suggestion = resp.data.resp;
          }
        })
      }
      delete props.tag.classes;
      delete props.tag.suggestion;
      delete props.tag.spell_error;
      delete props.tag.suggestion_visible;
      props.performSaveEdit(props.index);
    },
    handleReplaceone(props, item, idx) {
      props.performOpenEdit(props.index)
      props.tag.text = this.removeAt(props.tag.text, item.start_index, item.end_index, item.suggestion);
      this.handleRemoveitem(props, idx);
      // if (props.tag.suggestion.length == 0) {
      //   delete props.tag.classes;
      //   delete props.tag.suggestion;
      //   delete props.tag.suggestion_visible;
      // }
      props.performSaveEdit(props.index);
    },
    handleRemoveword(props, item, idx) {
      props.performOpenEdit(props.index);
      props.tag.text = this.removeAt(props.tag.text, item.start_index, item.end_index, '');
      this.handleRemoveitem(props, idx);
      // if (props.tag.suggestion.length == 0) {
      //   delete props.tag.classes;
      //   delete props.tag.suggestion;
      //   delete props.tag.suggestion_visible;
      // }
      props.performSaveEdit(props.index);
    },
    handleAddword(props, item, idx) {
      props.performOpenEdit(props.index);
      const text = props.tag.text;
      const suggestion = item.suggestion;
      const position = item.start_index;
      props.tag.text = [text.slice(0, position), " " + suggestion, text.slice(position)].join('');
      this.handleRemoveitem(props, idx);
      // if (props.tag.suggestion.length == 0) {
      //   delete props.tag.classes;
      //   delete props.tag.suggestion;
      //   delete props.tag.suggestion_visible;
      // }
      props.performSaveEdit(props.index);
    },
    handleRemoveitem(props, idx) {
      props.tag.suggestion = props.tag.suggestion.slice(0, idx).concat(props.tag.suggestion.slice(idx + 1, props.tag.suggestion.length))
    },
    removeAt(str, start_index, end_index, replacement) {
      return [str.slice(0, start_index), replacement, str.slice(end_index + 1)].join('');
    },
    handleUsingCleanUpText(props) {
      props.performOpenEdit(props.index);
      props.tag.text = props.tag.clean_text;
      props.performSaveEdit(props.index);
    },
    async getSpellcheckApi(origin_obj, action) {
      let obj = {...origin_obj}
      const url = `v1/study-sets/spellcheck`
      const payload = {"text": obj.tag.text}
      await axios.post(url, payload).then(resp => {
        if(resp.data.resp && resp.data.resp.length > 0) {
          const suggestion_filtered = resp.data.resp.filter(item => item.suggestion != null)
          if(obj.tag.is_cleanup) {
            obj.tag.classes = "spell-error-cleanup";
          } else {
            obj.tag.classes = "spell-error";
          }
          obj.tag.spell_error = true;
          obj.tag.suggestion = suggestion_filtered;
          obj.tag.suggestion_visible = false;
        } else {
          if(obj.tag.classes == "spell-error" || obj.tag.classes == "spell-error-cleanup")
            delete obj.tag.classes;
          delete obj.tag.suggestion;
          delete obj.tag.spell_error;
          delete obj.tag.suggestion_visible;
        }
        obj.tag.loading = false;
      })
    },
    async getComputedDictionary(origin_obj) {
      let obj = {...origin_obj}
      const url = `v1/study-sets/compute_dictionary`
      const payload = {"sentence": obj.tag.text, "user_lang": "en"}
      await axios.post(url, payload).then(resp => {
        if(resp.data) {
          obj.tag.clean_text = resp.data;
          if(obj.tag.clean_text != obj.tag.text) {
            if(obj.tag.spell_error) {
              obj.tag.classes = "spell-error-cleanup";
            } else {
              obj.tag.classes = "cleanup-text";
            }
            obj.tag.is_cleanup = true;
          } else {
            if(obj.tag.classes == "cleanup-text" || obj.tag.classes == "spell-error-cleanup")
              delete obj.tag.classes;
            delete obj.tag.is_cleanup;
          }
        }
      })
    }
    
  },
  watch: {
    currentTags: {
      handler: function () {
        if (this.currentTags) {
          this.tagCount = this.currentTags.length;
          this.hasSpellError = this.currentTags.filter(tag => tag.classes && tag.spell_error).length > 0;
          this.hasLimitError = this.currentTags.filter(tag => tag.classes && tag.limit_error).length > 0;
          this.hasCleanupText = this.currentTags.filter(tag => tag.classes && tag.is_cleanup).length > 0;
        } else {
          this.tagCount = 0
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/colors';
.count-elem {
  margin-left: auto;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: $black;
}

.el-tooltip.el-icon-info {
  margin-left: 3px;
  color: #546873 !important;
  font-size: 14px !important;
}
.elsa-tags-input-custom {
  ::v-deep {
    .ti-input {
      padding: 15px;
      .ti-tags {
        flex-direction: row !important;
        .custom-tag {
          div.ti-content {
            background: #B6D1FF !important;
          }
          .ti-actions {
            width: 18px;
          }
        }

        div.ti-content {
          padding: 7px 20px 7px 10px !important;
          margin-right: -25px;
        }
        span {
          font-size: 14px;
          font-weight: 590;
        }
      }
    }
    .ti-new-tag-input-wrapper {
      width: 100%;
    }

  }
}

.elsa-tags-input {
  min-height: 116px;
  max-width: none !important;
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  border-radius: 8px;
  

  &::v-deep .ti-input {
    border: none;
    font-family: 'SF Pro Display';
    .ti-tags {
      flex-direction: column;
    }
    .ti-new-tag-input {
      padding: 5px;
      padding-bottom: 30px;
      color: #121131 !important;
    }

    .ti-tag {
      font-weight: normal;
      font-size: 16px;
      line-height: 18px;
      color: $black;
      background: transparent !important;
      // border: 0.5px solid #cee0ea;
      .ti-content {
        // min-height: 32px;
        display: flex;
        align-items: center;
        gap: 5px;
        border: 0.5px solid #cee0ea;
        box-sizing: border-box;
        background: #e9e9ec !important;
        padding: 3px 5px;
        margin-right: -23px;
        padding-right: 24px;
        border-radius: 4px;
        // width: 100%;
        .ti-tag-left {
          height: 100%;
          display: flex;
          align-items: center;
        }
        .ti-tag-center {
          width: 100%;
          .ti-tag-input {
            display: flex;
            .el-textarea {
              padding-right: 5px; 
            }
          }
          .ti-tag-input textarea {
            color: #121131;
            padding: 5px;
            border: 1px solid #e9e9ec !important;
          }
          .tag-edit {
            display: flex;
            align-items: center;
          }
          .ti-icon-check {
            cursor: pointer;
            padding-left: 5px;
            font-size: 20px;
          }
        }
      }
      span {
        // padding: 0 8px 0 8px;
        line-height: 1.5;
      }
      .ti-actions {
        margin: 0px;
        color: $dark-blue-2;
      }

      &.ti-invalid {
        color: red;
      }
    }
    .ti-editing {
      .ti-content {
        width: 100%;
      }
    }
    
    .spell-error, .limit-error{
      .ti-content {
        // height: 32px;
        background: rgba(225, 91, 112, 0.3) !important;
        border-radius: 4px;
        padding: 3px 5px;
        margin-right: -23px;
        padding-right: 24px;
      }
      .ti-tag-center {
        // padding: 0 8px 0 8px;
        span {
          padding: 0;
          border-bottom: 2.5px solid #D91C4F;
        }
      }
    }
    .cleanup-text {
      .ti-content {
        // height: 32px;
        background: #ff9f00 !important;
        border-radius: 4px;
        padding: 3px 5px;
        margin-right: -23px;
        padding-right: 24px;
      }
    }
    .spell-error-cleanup {
      .ti-content {
        // height: 32px;
        background: #ff9f00 !important;
        border-radius: 4px;
        padding: 3px 5px;
        margin-right: -23px;
        padding-right: 24px;
      }
      .ti-tag-center {
        // padding: 0 8px 0 8px;
        span {
          padding: 0;
          border-bottom: 2.5px solid #D91C4F;
        }
      }
    }
  }
  
}
.check-spell {
  cursor: pointer;
  padding-left: 5px;
}
.warning-label, .cleanup-label {
  color: #F40C0C;
  font-size: 16px;
  line-height: 24px;
  display: inline-flex;

  &--custom {
    margin-left: 25px;
  }
  .elsa-icon-question {
    padding-left: 5px;
  }
}
.cleanup-label {
  color: #ff9f00;
}

.rotate{
 animation: loading 1s linear infinite;
 @keyframes loading {
  0% { 
    transform: rotate(0); 
  }
  100% { 
    transform: rotate(360deg);
  }
 }
}
</style>

